import axios from '@/libs/api.request'
var qs = require('qs')
    // 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: 'classes/classes-list',
        data,
        method: 'post'
    })
};
//查看课程
export const fetchLessonList = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: 'classes/lesson-list',
        data,
        method: 'post'
    })
};
//查看解锁状态
export const fetchLockList = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/classes/progress-list',
        data,
        method: 'post'
    })
};
export const fetchInfo = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/classes/info',
        data,
        method: 'post'
    })
};

export const addModify = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/classes/add-class',
        data,
        method: 'post'
    })
};